import React, { useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAlert } from "react-alert";
import { ResearcherContext } from "../../../ResearcherContext";
import DraftIcon from "../../../../../../assets/images/researcher_app/dashboard/status_draft_icon.png"
import OpenIcon from "../../../../../../assets/images/researcher_app/dashboard/status_open_icon.png"
import ClosedIcon from "../../../../../../assets/images/researcher_app/dashboard/status_closed_icon.png"
import PausedIcon from "../../../../../../assets/images/researcher_app/dashboard/status_paused_icon.png"
import EditIcon from "../../../../../../assets/images/researcher_app/dashboard/menu_edit_icon.png"
import DuplicateIcon from "../../../../../../assets/images/researcher_app/dashboard/menu_copy_icon.png"
import DeleteIcon from "../../../../../../assets/images/researcher_app/dashboard/menu_delete_icon.png"

// API Calls
import MissionsAPI from "../../api/api_calls/MissionAPI";

function MissionCardTitleRow(props) {
    return (
        <div className="missions-header">
            <div className="header-item"> </div>
            <div className="header-item">Created</div>
            <div className="header-item">Status</div>
            <div className="header-item">Completes</div>
            <div className="header-item">Project Type</div>
        </div>

    )
}

function MissionCards(props) {
    return (
        <div className="mission-card-container">
            {props.missions.map((mission, index) => {
                return (
                    <MissionCard key={index} mission={mission} updateMissions={props.updateMissions} />
                )
            })}
        </div>
    )
}

function MissionCard(props) {
    const navigate = useNavigate();
    const alert = useAlert();
    // If it's a draft mission, throw them back in the createmission flow. 
    // Put them at the top of the flow. Need to know if interview or survey to know which page to send them to.
    const navigatePath = props.mission.status == "draft" ?
        (props.mission.intended_mission_type == "interview" ? "/createmission/" + props.mission.id + "/sessiondetails" : "/createmission/" + props.mission.id + "/surveydetails")
        :
        "/missions/" + props.mission.id
        ;

    const completesText = props.mission.completes + "/" + (props.mission.num_total_spots ? props.mission.num_total_spots : "?");
    const completeProgressNumber = props.mission.num_total_spots ?
        Math.min((props.mission.completes / props.mission.num_total_spots * 100), 100) : 0;
    const completeProgress = (completeProgressNumber == 0 ? 1 : completeProgressNumber) + "%";

    // Duplicate the mission
    function duplicateMission() {
        console.log("Duplicating mission");

        async function duplicate() {
            const result = await MissionsAPI.duplicate({ missionId: props.mission.id, handleRedirect: navigate });

            if (result.success) {
                alert.success("Mission duplicated");
                props.updateMissions();
            } else {
                alert.error("Unable to duplicate mission. Please try again later.")
            }
        }
        duplicate();
    }

    // Delete it.
    function deleteMission() {
        console.log("Deleting mission");

        async function deleteIt() {
            const result = await MissionsAPI.delete({ missionId: props.mission.id, handleRedirect: navigate });

            if (result.success) {
                alert.success("Mission deleted");
                props.updateMissions();
            } else {
                alert.error(result.error)
            }
        }
        deleteIt();
    }

    return (
        <div className="mission-card-wrapper">
            <div className="mission-card" onClick={() => navigate(navigatePath)}>
                {/* <div className="mission-left-highlight" /> */}
                <div className="mission-card-grid">
                    <div className="mission-card-title-column">
                        <div className="mission-card-title">
                            {props.mission.name}
                        </div>
                        <div className="mission-card-description">
                            {props.mission.audience_description}
                        </div>
                    </div>
                    <div className="mission-stats-container">
                        <div className="mission-card-completes-container">
                            <div className="mission-card-completes-text-div">
                                <div className="mission-card-label-text">
                                    Completes
                                </div>
                                <div className="mission-card-completes-numbers">
                                    {completesText}
                                </div>
                            </div>
                            <div className="mission-card-progress-bar-container">
                                <div className="mission-card-progress-bar-background" />
                                <div className="mission-card-progress-bar-colored" style={{
                                    width: completeProgress
                                }} />
                            </div>
                        </div>
                        <div className="mission-card-item-container">
                            <div className="mission-card-label-text"> Created</div>
                            <div className="mission-card-value-text">{new Date(props.mission.created_at).toLocaleDateString('en-us', { month: "short", day: "numeric", year: "numeric" })}</div>
                        </div>
                        <div className="mission-card-item-container">
                            <div className="mission-card-label-text"> Type</div>
                            <div className="mission-card-value-text">{props.mission.mission_type}</div>
                        </div>
                    </div>
                    <div className="mission-card-status-container">
                        <StatusTag status={props.mission.status} />
                    </div>
                </div>
            </div>
            <div className="mission-card-options-button dropdown">
                <button className="three-dot-button" type="button" data-bs-toggle="dropdown" aria-expanded="false" />
                <ul className="dropdown-menu">
                    <li className="dropdown-li-div">
                        <div className="dropdown-item icon-and-text-item" onClick={() => navigate(navigatePath)}>
                            <img src={EditIcon} />
                            <div className="dropdown-menu-text">
                                Edit
                            </div>
                        </div>
                    </li>
                    <li className="dropdown-li-div">
                        <div className="dropdown-item icon-and-text-item" onClick={() => duplicateMission()}>
                            <img src={DuplicateIcon} />
                            <div className="dropdown-menu-text">
                                Duplicate
                            </div>
                        </div>
                    </li>
                    {props.mission.status == "draft" &&
                        <li className="dropdown-li-div">
                            <div className="dropdown-item icon-and-text-item" onClick={() => deleteMission()}>
                                <img src={DeleteIcon} />
                                <div className="dropdown-menu-text">
                                    Delete
                                </div>
                            </div>
                        </li>
                    }
                </ul>
            </div>
        </div>
    )
}

function StatusTag(props) {
    // Switch statement on props.status
    // Each returns a xXXStatusTag component

    switch (props.status) {
        case "draft":
            return <DraftStatusTag />
        case "open":
            return <OpenStatusTag />
        case "closed":
            return <ClosedStatusTag />
        case "paused":
            return <PausedStatusTag />
        default:
            return <UnknownStatusTag />
    }
}

function DraftStatusTag(props) {
    return (
        <div className="status-tag draft">
            <div className="status-tag-text">
                Draft
            </div>
            <img src={DraftIcon} />
        </div>
    )
}

function OpenStatusTag(props) {
    return (
        <div className="status-tag open">
            <div className="status-tag-text" >
                Open
            </div>
            <img src={OpenIcon} />
        </div>
    )
}

function ClosedStatusTag(props) {
    return (
        <div className="status-tag closed">
            <div className="status-tag-text">
                Closed
            </div>
            <img src={ClosedIcon} />
        </div>
    )
}

function PausedStatusTag(props) {
    return (
        <div className="status-tag paused">
            <div className="status-tag-text">
                Paused
            </div>
            <img src={PausedIcon} />
        </div>
    )
}

function UnknownStatusTag(props) {
    return (
        <div className="status-tag paused">
            <div >
                Unknown
            </div>
            <img src={PausedIcon} />
        </div>
    )
}


// function EmptyMissionsCard(props) {
//     const navigate = useNavigate();
//     const { researcher, setResearcher, refreshResearcher } = useContext(ResearcherContext);
//     const firstName = researcher.first_name || "Researcher"

//     return (
//         <Card>
//             <div className="empty-mission-card-container">
//                 <div className="empty-mission-card-title">
//                     Welcome, {firstName}!
//                 </div>
//                 <div className="empty-mission-card-bigger-gap-container">
//                     <div className="empty-mission-card-description">
//                         You have not created any research projects.
//                     </div>
//                     <PrimaryButton text="Create New Project" onClick={() => navigate("/createmission/")} />
//                 </div>
//             </div>
//         </Card>
//     )
// }

function EmptyMissionsCard(props) {
    return (
        <div className="empty-sessions-card">
            No missions created.
        </div>
    )
}

// function NoLaunchedMissionsCard(props) {
//     const { researcher, setResearcher, refreshResearcher } = useContext(ResearcherContext);
//     const firstName = researcher.first_name || "Researcher"

//     return (
//         <Card>
//             <div className="empty-mission-card-container">
//                 <div className="empty-mission-card-title">
//                     Welcome, {firstName}!
//                 </div>
//                 <div className="empty-mission-card-description">
//                     Your research projects, called Missions, are shown above. Once launched, you'll be able to manage research participants and responses. Click the card to continue setting up your Mission.
//                     <br />
//                     <br />
//                     <ul>
//                         <li>Launch surveys or set up live feedback sessions with users</li>
//                         <li>Specify your target audience through demographic, wallet, and other requirements</li>
//                         <li>Easily review and manage your Missions  </li>
//                         <li>Need something our portal doesn't support? Email us at info@despark.io. We can often handle it through our admin portal. </li>
//                     </ul>

//                     <br />
//                     Click your mission to continue editing it or click “Create New Mission” to create a different type.
//                 </div>
//             </div>
//         </Card>
//     )
// }



export { MissionCards, MissionCardTitleRow, EmptyMissionsCard };
